import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import * as yup from "yup";
import {
  Button,
  Box,
  Backdrop,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Grid,
  Typography,
  Dialog,
  Snackbar,
  Alert,
} from "@mui/material";
import DeleteIcon from "../../utils/images/UploadDocumentsDeleteIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import { InfoOutlined } from "@mui/icons-material";
import { Form, Formik } from "formik";
import { Col, Row, Container } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import BillDetails from "./billDetailsPage";
import SuccessClaim from "./successPage";
import UserDetailsForm from "./userBenefs";
import BankDetailsForm from "./userBankDetails";
import { Context } from "../../../context/DataProvider";
import Select from "../../customFiles/Select";
import "../../utils/css/CreateClaim.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../utils/css/main.css";
import SavedBills from "./savedBills";
import { safeJsonParse } from "../../utils/parser";
import loggingService from "../../../services/logging.service";
import { trackEvent } from "../../../config/eventHandlers";
import WarningDialog from "../claimForms/warningMessageDailog";
import MobileSecurityFooter from '../../customFiles/MobileSecurityFooter';
import {
  generateValidationSchema,
  getFormName,
  hasOptionalField,
  LocalStorageKeys,
  pageConfigurationCarouselIDs,
  pageConfigurationPageIDs,
  PRESCRIBED_PHARMACY_CONTRACT,
  PHARMACY_CONTRACT,
  VACCINATION_LABEL,
  VACCINATION_CONTRACT
} from "../../utils/constants/constants";
import { FileUploader, formatBytes, isSafeFilename,checkHarmfulPdfContent } from "../../utils/fileUploader";
import { DocumentType, OPDConfig, ScreenName, PRESCRIPTION_QUESTION_ENTITY_ID_LIST} from "../../../config/constants";
import billDetailsFormConstants from "../../utils/constants/billDetailsFormConstants.json";
import UploadedFilesPreview from "./UploadedFilesPreview";
import MobileBannerCarousel from "../../customFiles/MobileBannerCarousel";
import { dateConverter, TIMEZONES } from "../../../utils/dateUtils";
import { getBillCategories, sleep,handleBannerClick } from "../../utils/miscutils";
import { BENEF_MAP } from "../../utils/constants/constants";
import Carousel from "../../customFiles/Carousel";
import UploadIcons from "../../utils/images/upload2.svg";
import useTaskDeviceBridge from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { isMobile } from "../../utils/miscutils"
import { isWebView } from "../../utils/deviceUtils";
import { getRedirectToken } from "../../../utils/cookieUtils";
import axiosInstance from "../../../utils/axiosInterceptor";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function ClaimMain(props) {
  const navigate = useNavigate();
  const [users, setUser] = useState();
  const [bank, setBank] = useState();
  const [bankFlag, setBankFlag] = useState();
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(true);
  const [successClaim, setSuccessClaim] = useState(0);
  const [successToast, setSuccessToast] = useState({ show: false, message: "", key: 0 });
  const taskDeviceBridge = useTaskDeviceBridge();

  const apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL;
  const eventLogUrl = process.env.REACT_APP_EVENT_LOG_URL;
  const utm_source = localStorage.getItem("source")
    ? localStorage.getItem("source")
    : "web";
  const token = getRedirectToken();
  const benefMappedServices = localStorage.getItem("benefMappedServices");

  let apiFailure = false;
  let bankid = null;
  let billDocuments = [];
  let claim = "";
  let documentSize = 0;
  let previousSize = 0;


  let selectedPolicy = JSON.parse(localStorage.getItem("selectedPolicy")) || {};

  const authHeader = {
    headers: {
      authtoken: props.accessToken,
      entitypolicyid:
        selectedPolicy?.entityPolicyId ?? OPDConfig.Old_Policy_EntityPolicyId,
      subscriptionid:
        selectedPolicy?.primarySubscriptionId ??
        OPDConfig.Old_Policy_SubscriptionId,
    },
  };

  const userDetailsbody = {
    applicationId: 9194,
    authToken: props.accessToken,
  };
  const userAndBankDetails = async () => {
    try {
      const benefsDetails = await axiosInstance.post(
        `${apiUrl}/auth/getUserDetails`,
        userDetailsbody,
        authHeader
      );
      const benefsBankDetails = await axiosInstance.get(
        `${apiUrl}/auth/getUserBankDetails`,
        authHeader
      );
      localStorage.setItem(
        LocalStorageKeys.CURRENT_PM_ENTITY_ID,
        benefsDetails.data.result.pmEntityId
      );
      axios.all([benefsDetails, benefsBankDetails]).then(
        axios.spread((...allData) => {
          if (allData[0].data.isSuccess) {
            setUser(allData[0].data.result);
            // Store users data in localStorage for IR flow to access (persists across sessions)
            localStorage.setItem("users", JSON.stringify(allData[0].data.result));
          }
          if (!allData[0].data.isSuccess) {
            setMessage("Unable to Fetch Claim Details");
            setLoading(false);
          }
          if (allData[1].data.isSuccess) {
            if (allData[1].data.result.bankdta === "no bank records")
              setBank([]);
            else setBank(allData[1].data.result.bankdta);
            setBankFlag(allData[1].data.result.bankflag);
          }
          if (!allData[1].data.isSuccess) {
            setMessage("Unable to Fetch Claim Details");
            setLoading(false);
          }
        })
      );
    } catch (error) {
      setLoading(false);
      if (error.response.data.message === "Token_Expired")
        setMessage("Session expired please login again");
      else setMessage("Unable to fetch your claims");
    }
  };

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessToast((prev) => ({ ...prev, show: false }));
  };

  useEffect(() => {
    if (props.accessToken) {
      userAndBankDetails();
    } else {
      setMessage("You are un-authorised to view this page.");
      setLoading(false);
    }
  }, []);

  const getBeneficiaryDetails = useCallback(
    (values) => {
      // Find the beneficiary model using their name
      let benefName,
        benefGrade,
        relationId = "",
        benefId = "";
      if (users && values) {
        let beneficiary = users.benefs.find((user) => {
          return user.name === values.employeeDetails;
        });

        benefName = beneficiary ? beneficiary.name : "Name";
        benefGrade = beneficiary ? beneficiary.grade : "";
        relationId = beneficiary.relationId;
        benefId = beneficiary?.maid;
      }
      return {
        benefName,
        benefGrade,
        relationId,
        benefId,
      };
    },
    [users]
  );

  const submitStep1 = async (values) => {
    const { benefName, benefGrade, relationId, benefId } =
      getBeneficiaryDetails(values);

    const addUserBody = {
      mbuserid: users.mbUserId,
      pmentityid: users.pmEntityId,
      emailid: users.emailId,
      phonenumber: users.phoneNumber,
      name: benefName,
      uuid: users.uuid,
      relationid: relationId,
      grade: benefGrade,
      employeeid: users.employeeId.toString(),
      claimid: claim,
      bankid: bankFlag ? bank[bankid].accountholdernumber : null,
      source: utm_source,
      entitypolicyid:
        selectedPolicy?.entityPolicyId ?? OPDConfig.Old_Policy_EntityPolicyId,
      subscriptionid:
        selectedPolicy?.primarySubscriptionId ??
        OPDConfig.Old_Policy_SubscriptionId,
      beneficiaryid: Number(benefId),
    };
    let bankResponse;
    try {
      // change the endpoint back to initiateClaim later
      const res = await axios.post(
        `${apiUrl}/auth/initiateClaim`,
        addUserBody,
        {
          headers: {
            authtoken: props.accessToken || null,
          },
        }
      );
      bankResponse = res;
      if (bankResponse.data.isSuccess) {
        claim = bankResponse.data.result.claimdetails.result.claimid;
      }
      return bankResponse;
    } catch (error) {
      bankResponse = error.response;
      return bankResponse;
    }
  };

  const getBilldetailsApiPayload = (billFormDetails) => {
    try {
      let billDetailsJson = {};
      let additionalInfo = {};

      additionalInfo["pincode"] = Number(billFormDetails.pincode);
      additionalInfo["isfavourite"] =
        billFormDetails?.favDoctorName || billFormDetails?.favCenterName
          ? true
          : false;
      additionalInfo["outofnetwork"] =
        billFormDetails?.centerName && billFormDetails.centerName === "others"
          ? true
          : false;
      additionalInfo["category"] = billFormDetails.type;
      additionalInfo["speciality"] = billFormDetails?.doctorSpeciality;
      additionalInfo["doctorid"] = billFormDetails?.doctorRegisteredNumber;
      additionalInfo["doctorname"] = billFormDetails?.doctorName;
      additionalInfo["hospitalid"] = "";
      additionalInfo["hospitalname"] = billFormDetails?.centerName
        ? billFormDetails.centerName === "others"
          ? billFormDetails.otherCenterName
          : billFormDetails.centerName
        : "";
      additionalInfo["labid"] = "";
      additionalInfo["labname"] = billFormDetails?.centerName
        ? billFormDetails.centerName === "others"
          ? billFormDetails.otherCenterName
          : billFormDetails.centerName
        : "";
      additionalInfo["address"] = billFormDetails.centerAddress || "";
      additionalInfo["contactinfo"] = "";
      additionalInfo["additionals"] = {
        ...(!billFormDetails?.illnessType
          ? {}
          : {
              illnessType:
                billFormDetails?.illnessType === "others"
                  ? billFormDetails?.otherIllnessType
                  : billFormDetails?.illnessType,
            }),
        ...(!billFormDetails?.treatmentType
          ? {}
          : {
              treatmentType:
                billFormDetails?.treatmentType === "others"
                  ? billFormDetails?.otherTreatmentType
                  : billFormDetails?.treatmentType,
            }),
        ...((billFormDetails?.type === PRESCRIBED_PHARMACY_CONTRACT || billFormDetails?.type === PHARMACY_CONTRACT) &&
          PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(Number(users?.pmEntityId))
          ? {
              hasPrescription: billFormDetails?.hasPrescription || null,
              ...(billFormDetails?.hasPrescription === "no"
                ? { prescriptionReason: billFormDetails?.prescriptionReason || null }
                : {}),
            }
          : {}),
      };

      billDetailsJson["hospitalname"] = billFormDetails?.centerName
        ? billFormDetails.centerName === "others"
          ? billFormDetails.otherCenterName
          : billFormDetails.centerName
        : "";
      billDetailsJson["billdate"] = dateConverter(
        billFormDetails.billDate,
        TIMEZONES.UTC,
        "default"
      );
      billDetailsJson["billamount"] = billFormDetails.billAmount;
      billDetailsJson["category"] = billFormDetails.type;
      billDetailsJson["contractid"] = billFormDetails.contractId;
      billDetailsJson["billnumber"] = billFormDetails.billNumber;
      billDetailsJson["entityid"] = users.pmEntityId;
      billDetailsJson["grade"] = users.grade;
      billDetailsJson["claimid"] = claim;
      billDetailsJson["files"] = billFormDetails.doc;
      billDetailsJson["isirflow"] = 0;
      billDetailsJson["assetDetails"] = additionalInfo;

      return billDetailsJson;
    } catch (error) {
      console.log(error);
    }
  };

  const submitStep3 = async (bills) => {
    let billResponse,
      billDetailsArr = [];
      const currentBills = bills;
     for (let i = 0; i < currentBills.length; i++) {
    const billDetailsJson = getBilldetailsApiPayload(currentBills[i]);
    billDetailsArr.push(billDetailsJson);
  }
    try {
      const billResponse = await axiosInstance.post(
        `${apiUrl}/auth/addBillDetails`,
        billDetailsArr,
        {
          headers: {
            authtoken: props.accessToken || null,
          },
        }
      );

      if (billResponse.data.isSuccess) {
        setSuccessDialog(true);
        setSuccessClaim(claim);
      }
    } catch (error) {
      billResponse = error.response;
    }

    return { BillDetailsres: billResponse };
  };

  const [successDialog, setSuccessDialog] = useState(false);
  const Forms = ["User Details", "Bill Details"];
  const steps = ["User Details", "Bill Details"];

  function FormikStep({ children }) {
    // for debugging
    // const { errors, touched, values } = useFormikContext();
    // console.log("Errors on this step:", errors);

    return <>{children}</>;
  }
  function FormikStepper({
  children,
  checkForUnsavedChanges,
  goBackToConfirmation,
  formRef,
  onSaveBill,
  saveBillDisabled,
  selectedBillType,
  showBillForm,
  bills,
  isComingFromConfirmation,
  showWarningDialog,
  setShowWarningDialog,
  isDeclarationChecked,
  navigationMode,              
  setNavigationMode, 
  isInBillDetailsPage,         
  handleBillTypeChangeConfirm, 
  ...props
  }) {
    const childrenArray = React.Children.toArray(children);
    const [step, setStep] = useState(0);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const currentChild = childrenArray[step];

    const validationSchema = currentChild.props.validationSchema;

    const isLastStep = () => {
      return step === childrenArray.length - 1;
    };

    const PreviousForm = () => {
      setStep(step - 1);
    };

    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [step]);

    const isMobileView = useMemo(() => {
      return isMobile(window.innerWidth);
    }, [window.innerWidth]);

    const isSubmitDisabled = ({
      bankid,
      bank,
      step,
      bills,
      billDetails,
      billDocuments,
      isInBillDetailsPage,
      isSubmitting,
    }) => {
      const relationName = sessionStorage.getItem("relationName");
      let benef =
        users &&
        users.benefs.find((user) => {
          return user.name === relationName;
        });
      if (isSubmitting) return true;
      if (!benef) return true;
      if (!bankFlag) return false;
      if (bankFlag && (bankid === null || bankid === undefined)) return true;
      if (bankFlag && (!bank || bank.length === 0)) return true;
      if (step === 1 && bills.length === 0) return true; 
      if (step === 2 && billDocuments.length === 0) return true;
      if (step === 1 && isInBillDetailsPage) return true;
      if (bankid != null && bank != null && bank.length > 0) {
        return bank[bankid].isverified === 2;
      }
      return false;
    };

  const redirectAndLogEvent = (url) => {
  try {
    setTimeout(() => {
      if (isWebView()) {
        if (taskDeviceBridge && taskDeviceBridge.launchDeepLink) {
          taskDeviceBridge.launchDeepLink(`${url}`);
        } 
      } else {
         window.location.href = url;
      }
    }, 300);
  } catch (error) {
    console.error(error);
    return;
  }
};

const mobileBannerClickHandler = handleBannerClick(token, props.accessToken)(redirectAndLogEvent);


    const handleSubmit = async (values, helpers) => {
      setHasSubmitted(true);
      if (isLastStep()) {
        trackEvent.submitClaim({
          employee_email: users.emailId,
          screenName: ScreenName.CREATE_CLAIM,
        });
        let response = await submitStep3(bills);
        if (!response.BillDetailsres.data.isSuccess) {
          apiFailure = true;
        } else {
          apiFailure = false;
          await props.onSubmit(values, helpers);
        }
      } else {
        const { benefName } = getBeneficiaryDetails(values);
        trackEvent.userDetailsNext({
          patient_name: benefName,
          screenName: ScreenName.USER_DETAILS_NEXT,
          beneficiary_name: benefName,
        });
        if (step === 0) {
          let step1Res = await submitStep1(values, users);
          if (!step1Res.data.isSuccess) {
            await sleep(1000);
            apiFailure = true;
          } else {
            apiFailure = false;
            setStep(step + 1);
          }
        } else if (step === 1) {
          await sleep(400);
          setStep(step + 1);
        }
        helpers.setTouched({});
      }
    };
    const GradientConnector = ({ completed }) => (
      <StepConnector
        sx={{
          "& .MuiStepConnector-line": {
            borderTopWidth: 1,
            borderRadius: 1,
            transition: "all 0.3s ease",
            borderColor: "#A4B0C0",
            ...(completed && {
              background:
                "linear-gradient(60deg, #2970FF 0.2%, #0040C1 99.99%)",
              border: "none",
              height: 2,
            }),
          },
        }}
      />
    );

   const submitClaimHapticFeedback = async () => {
      try {
        await taskDeviceBridge.getHapticFeedBack("CLICK");
      } catch (error) {
        console.error("Submit claim haptic feedback error:", error);
      }
    };

  return (
    <Container fluid className="p-t-5 container-fluid-custom">
      <Row>
        <Col sm={12} xs={12}>
          <Formik
            {...props}
            validateOnBlur={hasSubmitted}
            validateOnChange={false}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({ isSubmitting, values }) => {
              return (
                <Form autoComplete="off">
                  <Box
                    sx={{
                      ...(isMobileView && {
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "calc(100vh - 100px)",
                      }),
                    }}
                  >
                    <Box
                      sx={{
                        ...(isMobileView && {
                          flex: 1,
                          paddingBottom: { xs: "20px", sm: "24px" },
                        }),
                      }}
                    >
                      {!isMobileView &&
                        <Stepper
                          activeStep={step}
                          sx={{
                            width: { xs: "90%", sm: "50%", lg: "35%" },
                            marginTop: { xs: "70px", sm: "0px" },
                            marginLeft: {
                              xs: "-55px",
                              sm: "-68px",
                              lg: "-80px",
                            },
                          }}
                          alternativeLabel
                          connector={<GradientConnector completed={step > 0} />}
                        >
                          {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            return (
                              <Step
                                aria-label={`Step: ${label}`}
                                aria-current={
                                  step === index ? "step" : undefined
                                }
                                key={label}
                                {...stepProps}
                                sx={{ padding: 0 }}
                                tabIndex="0"
                              >
                                <StepLabel
                                  {...labelProps}
                                  StepIconComponent={(props) => {
                                    const { active, completed } = props;

                                    return (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          width: "26px",
                                          height: "26px",
                                          padding: "8px",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          borderRadius: "999px",
                                          border:
                                            completed || active
                                              ? "1px solid #2970FF"
                                              : "1px solid #A4B0C0",
                                          background: completed
                                            ? "linear-gradient(60deg, #2970FF 0.2%, #0040C1 99.99%)"
                                            : active
                                            ? "#DBE8FF"
                                            : "#fff",
                                        }}
                                      >
                                        {completed ? (
                                          <CheckIcon
                                            sx={{
                                              color: "white",
                                              fontSize: "20px",
                                              "& path": {
                                                strokeWidth: 2,
                                              },
                                            }}
                                          />
                                        ) : active ? (
                                          <Box
                                            sx={{
                                              width: "9px",
                                              height: "9px",
                                              borderRadius: "50%",
                                              background:
                                                "linear-gradient(60deg, #2970FF 0.2%, #0040C1 99.99%)",
                                            }}
                                          />
                                        ) : null}
                                      </Box>
                                    );
                                  }}
                                  sx={{
                                    "& .MuiStepLabel-label": {
                                      marginTop: 1,
                                      fontSize: "14px",
                                      color: "#47566A",
                                      "&.Mui-active": {
                                        color: "#0066DC",
                                        fontWeight: 400,
                                      },
                                    },
                                  }}
                                >
                                  {label}
                                </StepLabel>
                              </Step>
                            );
                          })}
                        </Stepper>
                      }
                      {currentChild}
                      <br></br>
                      {apiFailure ? (
                        <p
                          style={{
                            marginTop: "10px",
                            color: "#FC1721",
                            display: "flex",
                            justifyContent: "end",
                            textAlign: "end",
                          }}
                        >
                          Something went wrong please try again &nbsp;
                        </p>
                      ) : null}
                      <WarningDialog
                        open={showWarningDialog}
                        onClose={() => {
                          setShowWarningDialog(false);
                          // If it was a bill type change, clean up and reset back to edit
                          if (navigationMode === "billTypeChange") {
                            delete window.pendingBillTypeChange;
                            setNavigationMode("edit"); // Reset back to edit mode
                          }
                        }}
                        onConfirm={() => {
                          if (navigationMode === "billTypeChange") {
                            handleBillTypeChangeConfirm();
                          } else {
                            goBackToConfirmation();
                          }
                        }}
                        changeType={
                          navigationMode === "billTypeChange"
                            ? "billType"
                            : "unsaved"
                        }
                      />
                    </Box>
                    {isMobileView && step === 1 && (selectedBillType || !showBillForm) && (
                      <Box
                        className="mobile-page-with-footer"
                        sx={{
                          paddingTop: "clamp(16px, 2.5vh, 24px)",
                          paddingBottom: "clamp(90px, 14vh, 130px)",
                          marginTop: "auto",
                        }}
                      >
                        <MobileSecurityFooter />
                      </Box>
                    )}
                    <Box
                      sx={{
                        ...(isMobileView && {
                          position: "fixed",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          backgroundColor: "#fff",
                          borderTop: "1px solid #E5E7EB",
                          padding: "0px",
                          marginBottom: "0px",
                          paddingBottom: "10px",
                          zIndex: 1000,
                          boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
                        }),
                      }}
                    >
                      <Container fluid className="container-fluid-custom">
                        <Grid
                          container
                          spacing={2}
                          marginTop={isMobileView ? "0px" : "3px"}
                        >
                          <Grid
                            item
                            sm={step === 1 && showBillForm ? 6 : 12}
                            md={step === 1 && showBillForm ? 6 : 12}
                            lg={
                              step === 1 && showBillForm
                                ? 6
                                : step === 1 && !showBillForm
                                ? 8
                                : 12
                            }
                            sx={{
                              display: "flex",
                              flexWrap: {
                                xs: "wrap",
                                sm:
                                  step === 1 && showBillForm
                                    ? "wrap"
                                    : "nowrap",
                              },
                              justifyContent:
                                step === 1 && !showBillForm
                                  ? { xs: "center", sm: "flex-start" }
                                  : "space-between",
                              marginBottom: isMobileView ? "12px" : "0px",
                              width: "100%",
                              gap: isMobileView ? 0 : 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent:
                                  step === 1 && !showBillForm
                                    ? "center"
                                    : "space-between",
                                gap: 2,
                                flexDirection: "row",
                                width:
                                  step === 1 && !showBillForm ? "100%" : "100%",
                              }}
                            >
                              {!(step === 1 && !showBillForm) &&
                                !(
                                  navigationMode === "edit" ||
                                  navigationMode === "billTypeChange"
                                ) && (
                                  <Box sx={{ flex: 1, marginLeft: "5px" }}>
                                    {step === 0 ? (
                                      // Step 0: Cancel button
                                      <Button
                                        variant="outlined"
                                        onClick={() => {
                                          navigate("/reimbursements");
                                        }}
                                        sx={{
                                          color: "#47566A",
                                          borderRadius: "8px",
                                          border: "1px solid #A4B0C0",
                                          minWidth: { sm: "150px", xs: "100%" },
                                          padding: {
                                            xs: "8px 12px",
                                            sm: "10px 16px",
                                            md: "12px 24px",
                                          },
                                          fontSize: "16px",
                                          fontWeight: 500,
                                          width: "100%",
                                          height: isMobileView
                                            ? "42px"
                                            : "48px",
                                          backgroundColor: "#fff",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          "&:hover": {
                                            borderColor: "#A4B0C0",
                                            backgroundColor: "#fff",
                                          },
                                        }}
                                      >
                                        Cancel
                                      </Button>
                                    ) : step === 1 && showBillForm ? (
                                      // Step 1 with bill form showing
                                      navigationMode === "add" ? (
                                        // Add mode: Show "Back to Confirmation Page" button
                                        <Button
                                          disabled={
                                            isSubmitting ||
                                            (!isComingFromConfirmation &&
                                              bills &&
                                              bills.length > 0)
                                          }
                                          variant="outlined"
                                          color="primary"
                                          onClick={() => {
                                            if (isComingFromConfirmation) {
                                              const hasChanges =
                                                checkForUnsavedChanges(values);
                                              if (hasChanges) {
                                                setShowWarningDialog(true);
                                              } else {
                                                goBackToConfirmation();
                                              }
                                            } else {
                                              PreviousForm();
                                            }
                                          }}
                                          sx={{
                                            color: "#47566A",
                                            borderRadius: "8px",
                                            border: "1px solid #A4B0C0",
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            marginLeft: "5px",
                                            height: isMobileView
                                              ? "42px"
                                              : "48px",
                                            backgroundColor: "#fff",
                                            padding: {
                                              xs: "8px 12px",
                                              sm: "10px 16px",
                                              md: "12px 24px",
                                            },
                                            width: {
                                              xs: "100%",
                                              sm: "auto",
                                            },
                                            minWidth: { sm: "200px" },
                                            whiteSpace: {
                                              xs: "normal",
                                              sm: "normal",
                                              md: "nowrap",
                                            },
                                            lineHeight: 1.2,
                                            textAlign: "center",
                                            "&:hover": {
                                              borderColor: "#A4B0C0",
                                              backgroundColor: "#fff",
                                            },
                                          }}
                                        >
                                          {isComingFromConfirmation &&
                                          !isMobileView
                                            ? "Back to Confirmation Page"
                                            : isComingFromConfirmation &&
                                              isMobileView
                                            ? "Back to Confirmation"
                                            : "Back"}
                                        </Button>
                                      ) : navigationMode === "edit" ||
                                        navigationMode ===
                                          "billTypeChange" ? null : (
                                        <Button
                                          disabled={
                                            isSubmitting ||
                                            (bills && bills.length > 0)
                                          }
                                          variant="outlined"
                                          color="primary"
                                          onClick={() => PreviousForm()}
                                          sx={{
                                            color: "#47566A",
                                            borderRadius: "8px",
                                            border: "1px solid #A4B0C0",
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            marginLeft: "5px",
                                            height: isMobileView
                                              ? "42px"
                                              : "48px",
                                            backgroundColor: "#fff",
                                            padding: {
                                              xs: "8px 12px",
                                              sm: "10px 16px",
                                              md: "12px 24px",
                                            },
                                            width: {
                                              xs: "100%",
                                              sm: "auto",
                                            },
                                            minWidth: { sm: "150px" },
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            "&:hover": {
                                              borderColor: "#A4B0C0",
                                              backgroundColor: "#fff",
                                            },
                                          }}
                                        >
                                          Back
                                        </Button>
                                      )
                                    ) : null}
                                  </Box>
                                )}
                              <Box
                                sx={{
                                  flex: 1,
                                  marginRight: "5px",
                                  marginLeft: "5px",
                                }}
                              >
                                <Button
                                  startIcon={
                                    isSubmitting ? (
                                      <CircularProgress size="1rem" />
                                    ) : null
                                  }
                                  disabled={
                                    isSubmitting ||
                                    (step === 0
                                      ? isSubmitDisabled({
                                          bankid,
                                          bank,
                                          step,
                                          bills: bills,
                                          billDocuments,
                                          isInBillDetailsPage,
                                          isSubmitting,
                                          values,
                                        })
                                      : step === 1 && showBillForm
                                      ? !selectedBillType
                                      : step === 1 && !showBillForm
                                      ? !bills ||
                                        bills.length === 0 ||
                                        !isDeclarationChecked
                                      : false)
                                  }
                                  variant="contained"
                                  color="primary"
                                  onClick={async () => {
                                    if (step === 1 && showBillForm) {
                                      await onSaveBill();
                                    } else {
                                      const isSubmitClaimButton =
                                        step === 1 && !showBillForm;

                                      const formElement =
                                        document.querySelector("form");
                                      if (formElement) {
                                        formElement.dispatchEvent(
                                          new Event("submit", {
                                            cancelable: true,
                                            bubbles: true,
                                          })
                                        );

                                        if (isSubmitClaimButton) {
                                          await submitClaimHapticFeedback();
                                        }
                                      }
                                    }
                                  }}
                                  type={
                                    step === 1 && showBillForm
                                      ? "button"
                                      : "submit"
                                  }
                                  sx={{
                                    minWidth: {
                                      sm:
                                        step === 1 && !showBillForm
                                          ? "100%"
                                          : "150px",
                                      xs: "100px",
                                    },
                                    width:
                                      step === 1 && !showBillForm
                                        ? "100%"
                                        : "100%",
                                    marginBottom: isMobileView
                                      ? "0px"
                                      : step === 1 && !showBillForm
                                      ? "50px"
                                      : "0",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    color: "#fff",
                                    height: isMobileView ? "42px" : "48px",
                                    padding: {
                                      xs: "8px 12px",
                                      sm: "10px 16px",
                                      md: "12px 24px",
                                    },
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    right: 0,
                                    backgroundColor: "#0066DC",
                                    "&:disabled": {
                                      backgroundColor: "#DBE0E6",
                                      color: "#8A99AD",
                                      border: "1px solid #BFC8D2",
                                    },
                                  }}
                                >
                                  {isSubmitting
                                    ? "Processing"
                                    : step === 1 && !showBillForm
                                    ? "Submit Claim"
                                    : "Save & Continue"}
                                </Button>
                              </Box>
                            </Box>
                            <br></br>
                          </Grid>
                        </Grid>
                      </Container>
                    </Box>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    
    </Container>
  );
  }

  function FormikForm() {
    const formRef = useRef(null);
    const fileInputRefs = useRef({});
    const errorRef = useRef();

    const [bill, setBill] = useState([]);
    const [files, setFiles] = useState([]);
    const [billErrorMessage, setBillErrorMessage] = useState();
    const { setBankSelected } = useContext(Context);
    const [categoryUploads, setCategoryUploads] = useState([]);
    const [isCategoryMandatory, setIsCategoryMandatory] = useState({});
    const [billsObj, setBillsObj] = useState({});
    const [billsObjSize, setBillsObjSize] = useState({});
    const [billsObjName, setBillsObjName] = useState({});
    const [isUploading, setIsUploading] = useState({});
    const [isDisabled, setIsDisabled] = useState(0);
    const [saveBillDisabled, setsaveBillDisabled] = useState(false);
    const [getRulesMessage, setGetRulesMessage] = useState();
    const [docsErrorMessage, setDocsErrorMessage] = useState({});
    const [selectedBillType, setSelectedBillType] = useState();
    const [showBillForm, setShowBillForm] = useState(true);
    const [isEditBill, setIsEditBill] = useState(false);
    const [billRules, setBillRules] = useState(null);
    const [contractId, setContractId] = useState(null);
    const [billsObjFileObjects, setBillsObjFileObjects] = useState({});
    const [isInBillDetailsPage, setIsInBillDetailsPage] = useState(true);

    const [previewModal, setPreviewModal] = useState({
      open: false,
      url: null,
      isPdf: false,
      name: "",
      fileObject: null,
    });
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [isComingFromConfirmation, setIsComingFromConfirmation] =
      useState(false);
    const [navigationMode, setNavigationMode] = useState(""); 
    const [showWarningDialog, setShowWarningDialog] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [initialFormValues, setInitialFormValues] = useState(null);
    const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
    const [selectedBeneficiary, setSelectedBeneficiary] = useState(
      sessionStorage.getItem("relationName") || ""
    );

useEffect(() => {
  documentSize = 0;
  bill.forEach(billItem => {
    if (billItem._actualFileObjects) {
      Object.values(billItem._actualFileObjects).forEach(files => {
        if (Array.isArray(files)) {
          files.forEach(file => {
            documentSize += file.size || 0;
          });
        }
      });
    }
  });
}, [bill]);


    const onDocumentLoadSuccess = ({ numPages }) => {
      setNumPages(numPages);
      setPageNumber(1);
    };

    let tempObj = {};
    let tempObjName = {};
    let tempObjSize = {};
    let tempObjUploading = {};

    const onSelectBankHandler = (index) => {
      const bankHandler = {
        index,
      };
      setBankSelected(bankHandler.index);
      bankid = bankHandler.index;
    };

    const validateBillForm = async (billDetailsFormData, formName) => {
      const validationSchema = generateValidationSchema(
        formName,
        billDetailsFormConstants
      );
      try {
        // throws an error in case of validation failure
        await validationSchema.validate(billDetailsFormData);
        return { valid: true };
      } catch (error) {
        const errorMsg = error.toString().split(":")[1]?.trim();
        setBillErrorMessage(errorMsg);
        return { valid: false, errorField: error.path };
      }
    };

    const getContractIdForCategory = useCallback((categoryName) => {
      try {
        const categoriesV2 = JSON.parse(
          localStorage.getItem("categoriesV2") || "[]"
        );
        const category = Array.isArray(categoriesV2)
          ? categoriesV2.find((cat) => cat.category === categoryName)
          : categoriesV2[categoryName];

        const contractId = category?.contractid || null;
        return contractId;
      } catch (error) {
        console.error("[ClaimMain] Error getting contract ID:", error);
        return null;
      }
    }, []);
const addBillRow = async () => {
  let showBillFlag = false;
  let cflag = 1;

  for (let i = 0; i < Object.keys(isCategoryMandatory).length; i++) {
    var keyValues = Object.keys(isCategoryMandatory);
    var errorArray = "";

    keyValues.map((row, index) => {
      if (isCategoryMandatory[row] == 1) {
        const isPrescriptionOptional =
          row === DocumentType.PRESCRIPTION &&
          (selectedBillType === PRESCRIBED_PHARMACY_CONTRACT || selectedBillType === PHARMACY_CONTRACT) &&
          PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(Number(users?.pmEntityId));

        if (
          !isPrescriptionOptional &&
          (!billsObj[row] ||
          (billsObj[row] && billsObj[row].length <= 0))
        ) {
          cflag = 0;
          if (focusOnErrorRef.current) {
            focusOnErrorRef.current({ [row]: true });
          }
          const currentEntityId = Number(localStorage.getItem(LocalStorageKeys.CURRENT_PM_ENTITY_ID));
          const label = (row === DocumentType.PRESCRIPTION && selectedBillType===VACCINATION_CONTRACT && PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(currentEntityId))
            ? VACCINATION_LABEL
            : row.replace(/_/g, " ");
          if (errorArray)
            errorArray = errorArray + ", " + label;
          else errorArray = label;
        }
      }
    });
  }

  if (cflag) {
    const validationResult = await validateBillForm(
      formRef.current.values,
      selectedBillType
    );

    if (validationResult.valid) {
      let date = new Date(formRef.current.values.date);
      let todayDate = new Date();
      let billData = formRef.current.values;

      let billFlag = false;
      bill.map((row) => {
        if (
          row.billNumber === formRef.current.values.billNumber &&
          row.type === formRef.current.values.type
        ) {
          billFlag = true;
        }
        return row;
      });

      if (date > todayDate) {
        setBillErrorMessage("Bill date should not be in future");
        errorRef.current.focus();
        return false;
      } else if (
        !(formRef.current.values.billAmount > 0) ||
        formRef.current.values.billAmount.includes(".")
      ) {
        setBillErrorMessage(
          "Bill amount should be greater than 0 and should be a whole number"
        );
        errorRef.current.focus();
        return false;
      } else if (!billFlag) {
        const row = [...bill, billData];
      
         billData["doc"] = JSON.parse(JSON.stringify(billsObj));
         billData["docNames"] = JSON.parse(JSON.stringify(billsObjName));
         billData["categoryUploads"] = JSON.parse(
           JSON.stringify(categoryUploads)
         );
    
           const actualFileObjects = {};
           Object.keys(billsObjFileObjects).forEach((category) => {
             if (Array.isArray(billsObjFileObjects[category])) {
               actualFileObjects[category] = [...billsObjFileObjects[category]];
             } else {
               actualFileObjects[category] = billsObjFileObjects[category];
             }
           });
           billData["_actualFileObjects"] = actualFileObjects;
        
        const currentContractId = getContractIdForCategory(selectedBillType);
        billData["contractId"] = currentContractId;
        documentSize = 0;
        showBillFlag = true;
        setIsInBillDetailsPage(false);

        setBill(row);

        setBillErrorMessage();
        setShowBillForm(false);
        setDocsErrorMessage({});
        setSelectedBillType(null);
        setIsComingFromConfirmation(false);
        setNavigationMode("");
        setHasUnsavedChanges(false);
        setInitialFormValues(null);
        setIsEditBill(false);
        
        setBillsObj({});
        setBillsObjName({});
        setBillsObjSize({});
        setBillsObjFileObjects({});
        setCategoryUploads([]);
        setIsCategoryMandatory({});

        formRef.current.setValues({
          ...formRef.current.initialValues,
          pincode: formRef.current.values.pincode,
        });

        trackEvent.saveBill({
          service_name: selectedBillType,
          screenName: ScreenName.CREATE_CLAIM,
          pincode: formRef.current.values.pincode,
        });

        return true;
      } else if (billFlag) {
        setBillErrorMessage(
          "You have already added this bill number below. Please delete that bill and add again."
        );
        errorRef.current.focus();
        return false;
      } else {
        setBillErrorMessage("Please add a different bill");
        errorRef.current.focus();
        return false;
      }
    } else {
      if (focusOnErrorRef.current && validationResult.errorField) {
        focusOnErrorRef.current({ [validationResult.errorField]: true });
      }
      errorRef.current.focus();
      return false;
    }
  } else {
    setBillErrorMessage(`Please upload ${errorArray} files`);
    errorRef.current.focus();
    return false;
  }
};

    const deleteBillRow = (index) => {
      const rows = [...bill];
      rows.splice(index, 1);
      setBill(rows);
      setBillErrorMessage();
    };
    const editBillRow = (index) => {
      const billInfo = bill[index];

      setIsEditBill(true);
      setSelectedBillType(billInfo.type);
      setIsComingFromConfirmation(true);
      setNavigationMode("edit");

      setIsInBillDetailsPage(true);

      const originalBillType = billInfo.type;

      const initialValues = {
        ...JSON.parse(
          JSON.stringify({
            ...billInfo,
            _actualFileObjects: undefined,
          })
        ),
        _actualFileObjects: billInfo._actualFileObjects
          ? (() => {
              const cloned = {};
              Object.keys(billInfo._actualFileObjects).forEach((category) => {
                cloned[category] = Array.isArray(
                  billInfo._actualFileObjects[category]
                )
                  ? [...billInfo._actualFileObjects[category]]
                  : billInfo._actualFileObjects[category];
              });
              return cloned;
            })()
          : {},
        _originalBillType: originalBillType,
      };

      setInitialFormValues(initialValues);

      formRef.current.setValues({
        ...billInfo,
      });

      if (billInfo.categoryUploads) {
        setCategoryUploads([...billInfo.categoryUploads]);
        const mandatoryMapping = {};
        billInfo.categoryUploads.forEach((t) => (mandatoryMapping[t] = 1));
        setIsCategoryMandatory(mandatoryMapping);
      }

      if (billInfo.doc) {

        setBillsObj(JSON.parse(JSON.stringify(billInfo.doc)));
        setBillsObjName(JSON.parse(JSON.stringify(billInfo.docNames || {})));

        if (billInfo._actualFileObjects) {
          const clonedFileObjects = {};
          Object.keys(billInfo._actualFileObjects).forEach((category) => {
            clonedFileObjects[category] = Array.isArray(
              billInfo._actualFileObjects[category]
            )
              ? [...billInfo._actualFileObjects[category]]
              : billInfo._actualFileObjects[category];
          });
          setBillsObjFileObjects(clonedFileObjects);

        } else {
          setBillsObjFileObjects({});
        }

        const reconstructedSizes = {};
        if (billInfo._actualFileObjects) {
          Object.keys(billInfo.doc).forEach((category) => {
            reconstructedSizes[category] = {};
            billInfo.doc[category].forEach((fileKey, idx) => {
              const fileObjArray = billInfo._actualFileObjects[category];
              const fileObj = Array.isArray(fileObjArray)
                ? fileObjArray[idx]
                : fileObjArray;
              if (fileObj) {
                reconstructedSizes[category][fileKey] = fileObj.size || 0;
              }
            });
          });
        }

        setBillsObjSize(reconstructedSizes);
      } else {
        setBillsObj({});
        setBillsObjName({});
        setBillsObjSize({});
        setBillsObjFileObjects({});
      }

      setIsUploading({});
      setDocsErrorMessage({});
      documentSize = 0;
      setsaveBillDisabled(false);
      setGetRulesMessage();

      setShowBillForm(true);
      deleteBillRow(index);
    };
    const addAnotherBillHandler = (value) => {
      setIsInBillDetailsPage(value);
      setShowBillForm(value);
      if (value) {
        setIsComingFromConfirmation(true);
        setNavigationMode("add");
        setInitialFormValues({
          ...formRef.current.initialValues,
          pincode: formRef.current.values.pincode,
        });
        setIsDeclarationChecked(false); 
      }
    };

    const addBillDocuements = async (documents, index) => {
      const maxBillSize = 52428800;
      setIsDisabled(1);
      let tempErrorMessage = {};
      tempErrorMessage[categoryUploads[index]] = [];
      setDocsErrorMessage(tempErrorMessage);
      tempObjUploading = isUploading;
      if (!tempObjUploading[categoryUploads[index]]) {
        tempObjUploading[categoryUploads[index]] = [];
      }

      tempObjUploading[categoryUploads[index]] = 1;
      setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
      let documentType = false;

      for (var i = 0; i < documents.length; ++i) {
            if (!isSafeFilename(documents[i].name)) {
              tempErrorMessage[categoryUploads[index]].push("File name contains unsupported characters. Please use letters, numbers, or basic symbols only.");
              setDocsErrorMessage(tempErrorMessage);
              tempObjUploading[categoryUploads[index]] = 0;
              setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
              setIsDisabled(0);
              return;
            }
          }

        try {
          const isPdfSafe = await checkHarmfulPdfContent(documents);
          if (!isPdfSafe) {
            tempErrorMessage[categoryUploads[index]].push(
              "Invalid or harmful file detected. Please upload valid PDF files only."
            );
            setDocsErrorMessage(tempErrorMessage);
            tempObjUploading[categoryUploads[index]] = 0;
            setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
            setIsDisabled(0);
            return;
          }
        } catch (error) {
          tempErrorMessage[categoryUploads[index]].push(
            "Error validating PDF content. Please try again."
          );
          setDocsErrorMessage(tempErrorMessage);
          tempObjUploading[categoryUploads[index]] = 0;
          setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
          setIsDisabled(0);
          return;
        }

      if (JSON.stringify(billsObjSize) == JSON.stringify({})) {
        previousSize = 0;
        documentSize = 0;
        for (var i = 0; i < documents.length; ++i) {
          documentSize += documents[i].size;
          if (
            !(
              (documents[i].type === "application/pdf") |
              (documents[i].type === "image/png") |
              (documents[i].type === "image/jpg") |
              (documents[i].type === "image/jpeg")
            )
          ) {
            documentType = true;
          }
        }
      } else if (documentSize > maxBillSize) {
        tempErrorMessage[categoryUploads[index]].push(
          "Total File Size is beyond 50MB"
        );
        setDocsErrorMessage(tempErrorMessage);
        tempObjUploading[categoryUploads[index]] = 0;
        setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
      } else {
        previousSize = documentSize;
        for (var i = 0; i < documents.length; ++i) {
          documentSize += documents[i].size;
          if (
            !(
              (documents[i].type === "application/pdf") |
              (documents[i].type === "image/png") |
              (documents[i].type === "image/jpg") |
              (documents[i].type === "image/jpeg")
            )
          ) {
            documentType = true;
          }
        }
      }
      if (documentType) {
        documentSize = previousSize;
        tempErrorMessage[categoryUploads[index]].push(
          "Please upload pdf, png, jpg files only "
        );
        const fileSize = formatBytes(documents[0].size);
        const failureEventPayload = {
          message: JSON.stringify({
            raw_file_size: documents[0].size.toString(),
            file_size: fileSize,
          }),
          orderid: claim,
          screenName: ScreenName.CREATE_CLAIM,
          errormsg: "Wrong file type uploaded " + documents[0].type,
          errorResponse: "",
        };
        if (categoryUploads[index] === DocumentType.BILL_INVOICE) {
          trackEvent.uploadBillFail(failureEventPayload);
        } else if (categoryUploads[index] === DocumentType.PRESCRIPTION) {
          trackEvent.uploadRxFail(failureEventPayload);
        } else if (categoryUploads[index] === DocumentType.LAB_REPORT) {
          trackEvent.uploadReportFail(failureEventPayload);
        }
        setDocsErrorMessage(tempErrorMessage);
        tempObjUploading[categoryUploads[index]] = 0;
        setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
        setIsDisabled(0);
      } else if (documentSize > maxBillSize) {
        documentSize = previousSize;
        tempErrorMessage[categoryUploads[index]].push(
          "Total File Size is beyond 50MB"
        );
        const fileSize = formatBytes(documents[0].size);
        const failureEventPayload = {
          message: JSON.stringify({
            raw_file_size: documents[0].size.toString(),
            file_size: fileSize,
          }),
          orderid: claim,
          screenName: ScreenName.CREATE_CLAIM,
          errormsg: "Overall file size uploaded beyond 50MB",
          errorResponse: "",
        };
        if (categoryUploads[index] === DocumentType.BILL_INVOICE) {
          trackEvent.uploadBillFail(failureEventPayload);
        } else if (categoryUploads[index] === DocumentType.PRESCRIPTION) {
          trackEvent.uploadRxFail(failureEventPayload);
        } else if (categoryUploads[index] === DocumentType.LAB_REPORT) {
          trackEvent.uploadReportFail(failureEventPayload);
        }
        setDocsErrorMessage(tempErrorMessage);
        tempObjUploading[categoryUploads[index]] = 0;
        setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
        setIsDisabled(0);
      } else {
        let x = Math.random();
        billDocuments = [];
        billDocuments.push(...documents);
        for (var i = 0; i < billDocuments.length; ++i) {
          let claimid = claim;
          let formdata = new FormData();
          let today = new Date();
          let dd = String(today.getDate()).padStart(2, "0");
          let mm = String(today.getMonth() + 1).padStart(2, "0");
          let yyyy = today.getFullYear();
          let date = new Date();
          let hour = date.getHours();
          let min = date.getMinutes();
          let sec = date.getSeconds();
          let milli = date.getMilliseconds();
          today =
            yyyy +
            "_" +
            mm +
            "_" +
            dd +
            "_" +
            hour +
            "_" +
            min +
            "_" +
            sec +
            "_" +
            milli;
          let billDocname = billDocuments[i].name.split(".");
          let fileName =
            billDocname[0] +
            "_" +
            claimid +
            "_" +
            i.toString() +
            "_" +
            today +
            "." +
            billDocname[billDocname.length - 1];
          let fileType = "ClaimDocuments";
          let imageType = `image/${fileName.split(".").pop()}`;
          let singleFiledata = new File([documents[i]], fileName, {
            type: imageType,
          });

          let uploadResponse = {
            isSuccess: false,
            result: [{ Key: `${fileType}/${fileName}` }],
          };
          try {
            let pmEntityId = 0;
            const parsedEligibleColumns = safeJsonParse(props?.eligibleColumns);
            if (parsedEligibleColumns && parsedEligibleColumns.length > 0) {
              pmEntityId = parsedEligibleColumns[0].pmentityid;
            }
            const fileUploaderResponse = await FileUploader.uploadFileData(
              pmEntityId,
              singleFiledata,
              fileType
            );

            uploadResponse.isSuccess = fileUploaderResponse.isSuccess;
            uploadResponse.result = [{ Key: fileUploaderResponse.fileName }];
            if (uploadResponse && uploadResponse.isSuccess) {
              const fileSize = formatBytes(documents[0].size);
              const fileEventPayload = {
                message: JSON.stringify({
                  raw_file_size: documents[0].size.toString(),
                  file_size: fileSize,
                }),
                screenName: ScreenName.CREATE_CLAIM,
                orderid: claimid,
              };
              if (categoryUploads[index] === "Bill_Invoice") {
                trackEvent.uploadBillSuccess(fileEventPayload);
              } else if (categoryUploads[index] === "Prescription") {
                trackEvent.uploadRxSuccess(fileEventPayload);
              } else if (categoryUploads[index] === "LabReport") {
                trackEvent.uploadReportSuccess(fileEventPayload);
              }

           
              tempObj = JSON.parse(JSON.stringify(billsObj));
              tempObjSize = JSON.parse(JSON.stringify(billsObjSize));
              tempObjName = JSON.parse(JSON.stringify(billsObjName));
              tempObjUploading[categoryUploads[index]] = 0;
              setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));

              if (!tempObj[categoryUploads[index]]) {
                tempObj[categoryUploads[index]] = [];
              }

              tempObj[categoryUploads[index]].push(
                uploadResponse.result[0].Key
              );

              setBillsObj(tempObj);
              if (!tempObjName[categoryUploads[index]]) {
                tempObjName[categoryUploads[index]] = [];
              }

              let strr = billDocuments[i].name;
              if (billDocuments[i].name.length > 10) {
                strr = billDocuments[i].name.substring(0, 20) + "...";
              }

              tempObjName[categoryUploads[index]].push(strr);
              setBillsObjName(tempObjName);

              let tempObjFileObjects = { ...billsObjFileObjects };
              if (!tempObjFileObjects[categoryUploads[index]]) {
                tempObjFileObjects[categoryUploads[index]] = [];
              }
              tempObjFileObjects[categoryUploads[index]] = [
                ...(tempObjFileObjects[categoryUploads[index]] || []),
                billDocuments[i],
              ];
              setBillsObjFileObjects(tempObjFileObjects);

              if (!tempObjSize[categoryUploads[index]]) {
                tempObjSize[categoryUploads[index]] = {};
              }
              tempObjSize[categoryUploads[index]][
                uploadResponse.result[0].Key
              ] = billDocuments[i].size;
              setBillsObjSize(tempObjSize);
            } else {
              isUploading[categoryUploads[index]] = 0;
            }
          } catch (error) {
            loggingService.log({
              level: "ERROR",
              method: "POST/PUT",
              message: `Error in uplodaing File :  ${error.message}`,
              error: error.stack,
            });
            const fileSize = formatBytes(documents[0].size);
            const failureEventPayload = {
              message: JSON.stringify({
                raw_file_size: documents[0].size.toString(),
                file_size: fileSize,
              }),
              orderid: claimid,
              errormsg: error.toString(),
              errorResponse: error.stack ?? "",
              screenName: ScreenName.CREATE_CLAIM,
            };
            if (categoryUploads[index] === DocumentType.BILL_INVOICE) {
              trackEvent.uploadBillFail(failureEventPayload);
            } else if (categoryUploads[index] === DocumentType.PRESCRIPTION) {
              trackEvent.uploadRxFail(failureEventPayload);
            } else if (categoryUploads[index] === DocumentType.LAB_REPORT) {
              trackEvent.uploadReportFail(failureEventPayload);
            }
            tempObjUploading[categoryUploads[index]] = 0;
            setIsUploading(JSON.parse(JSON.stringify(tempObjUploading)));
            setIsDisabled(0);
            uploadResponse = error.response;
          }
        }
        setIsDisabled(0);
        setFiles(x);
      }
    };

const deleteSelectedFile = (index, indexx) => {
  let filerows = JSON.parse(JSON.stringify(billsObj[categoryUploads[index]] || []));
  let rows = JSON.parse(JSON.stringify(billsObjName[categoryUploads[index]] || []));
  let newBillsObj = JSON.parse(JSON.stringify(billsObj));
  let newBillsObjName = JSON.parse(JSON.stringify(billsObjName));
  let newBillsObjSize = JSON.parse(JSON.stringify(billsObjSize));
  
  let newBillsObjFileObjects = { ...billsObjFileObjects };
  
  if (billsObj !== null && billsObjSize[categoryUploads[index]]) {
    const fileKey = billsObj[categoryUploads[index]][indexx];
    if (billsObjSize[categoryUploads[index]][fileKey]) {
      documentSize -= billsObjSize[categoryUploads[index]][fileKey];
    }
  }
  
  const categoryName = categoryUploads[index] || null;
  
  if (categoryName != null && newBillsObjSize[categoryName]) {
    let categoryBillSize = newBillsObjSize[categoryName];
    const keyToDelete = Object.keys(categoryBillSize)[indexx];
    let newCategoryBillSize = {};
    
    Object.keys(categoryBillSize).forEach((key) => {
      if (keyToDelete !== key) {
        newCategoryBillSize[key] = categoryBillSize[key];
      }
    });
    newBillsObjSize[categoryName] = newCategoryBillSize;
  }
  
  filerows.splice(indexx, 1);
  rows.splice(indexx, 1);
  
  newBillsObj[categoryUploads[index]] = filerows;
  newBillsObjName[categoryUploads[index]] = rows;
  
  if (newBillsObjFileObjects[categoryUploads[index]]) {
    let fileObjectsArray = Array.isArray(newBillsObjFileObjects[categoryUploads[index]]) 
      ? [...newBillsObjFileObjects[categoryUploads[index]]] 
      : [];
    fileObjectsArray.splice(indexx, 1);
    newBillsObjFileObjects[categoryUploads[index]] = fileObjectsArray;
  }
  
  setBillsObj(newBillsObj);
  setBillsObjName(newBillsObjName);
  setBillsObjSize(newBillsObjSize);
  setBillsObjFileObjects(newBillsObjFileObjects);
  
  setFiles(Math.random());
  
};

  const filesToBeUploadedBasedOnBillType = async (value) => {
  await sleep(300);
  
  const hasExistingDocuments = Object.keys(billsObj).length > 0;
  const isChangingBillType = selectedBillType && selectedBillType !== value;
  
  if (isEditBill && isChangingBillType && hasExistingDocuments) {
    console.warn('⚠️ Bill type changed in edit mode with existing documents');
    
  setNavigationMode("billTypeChange");
    setShowWarningDialog(true);
    window.pendingBillTypeChange = value;
    
    if (formRef.current) {
      formRef.current.setFieldValue('type', selectedBillType);
    }
    return;

  }
  
  setSelectedBillType(value);
  setsaveBillDisabled(true);

  let uploadTypesFromV2 = [];
  let selectedContractId = null;
  try {
    const categoriesV2 = JSON.parse(
      localStorage.getItem("categoriesV2") || "[]"
    );

    const selectedCategoryV2 = categoriesV2.find(
      (cat) => cat.category === value
    );

    if (selectedCategoryV2 && selectedCategoryV2.dynamicBill) {
      uploadTypesFromV2 = Array.isArray(selectedCategoryV2.dynamicBill)
        ? selectedCategoryV2.dynamicBill
        : typeof selectedCategoryV2.dynamicBill === "string"
        ? JSON.parse(selectedCategoryV2.dynamicBill)
        : [];
      selectedContractId = selectedCategoryV2.contractid || null;
    }
  } catch (e) {
    console.error("Error reading categoriesV2 dynamicBill:", e);
  }

  if (uploadTypesFromV2.length > 0) {
    setCategoryUploads(uploadTypesFromV2);
    const mandatoryMapping = {};
    uploadTypesFromV2.forEach((t) => (mandatoryMapping[t] = 1));
    setIsCategoryMandatory(mandatoryMapping);
    setContractId(selectedContractId);
    setsaveBillDisabled(false);
    setGetRulesMessage();
    setBillRules(null);
    
    setBillsObj({});
    setBillsObjName({});
    setBillsObjFileObjects({});
    setIsUploading({});
    documentSize = 0;
    setBillsObjSize({});
    setDocsErrorMessage({});
    formRef?.current?.setTouched({});
    
    return;
  }

  const selectedPolicy =
    JSON.parse(localStorage.getItem("selectedPolicy")) || {};
  const billTypeBody = {
    entityid: users.pmEntityId,
    category: value,
    entitypolicyid:
      selectedPolicy?.entityPolicyId ?? OPDConfig.Old_Policy_EntityPolicyId,
    subscriptionid:
      selectedPolicy?.primarySubscriptionId ??
      OPDConfig.Old_Policy_SubscriptionId,
  };
  
  setBillsObj({});
  setBillsObjName({});
  setBillsObjFileObjects({});
  setIsUploading({});
  documentSize = 0;
  setBillsObjSize({});
  setDocsErrorMessage({});

  try {
    const rules = await axiosInstance.post(
      `${apiUrl}/admin/getRules`,
      billTypeBody,
      {
        headers: {
          authtoken: props.accessToken || null,
        },
      }
    );

    if (rules.data.isSuccess && rules.data.result.length > 0) {
      setGetRulesMessage();
      setsaveBillDisabled(false);
      const dynamicbillObj = JSON.parse(rules.data.result[0].dynamicbill);
      setCategoryUploads(Object.keys(dynamicbillObj));
      setIsCategoryMandatory(dynamicbillObj);
      setBillRules(rules.data.result[0]);
    } else {
      setGetRulesMessage(
        "Bill uploads are not available at the moment. Please try again later."
      );
      setsaveBillDisabled(true);
    }
  } catch (error) {
    console.error(error);
    if (error.response?.data?.message === "Token_Expired")
      setGetRulesMessage("Session expired please login again");
    else setGetRulesMessage("Something went wrong please try again");
  }
};

const createResetFormValues = (initialValues, preserveFields = {}) => {
  const resetValues = {};
  
  Object.keys(initialValues).forEach((key) => {
    if (preserveFields.hasOwnProperty(key)) {
      resetValues[key] = preserveFields[key];
    } else {
      const initialValue = initialValues[key];
      resetValues[key] = Array.isArray(initialValue) ? [] : "";
    }
  });
  
  return resetValues;
};

const handleBillTypeChangeConfirm = useCallback(async () => {
  setShowWarningDialog(false);
  
  const newBillType = window.pendingBillTypeChange;
  delete window.pendingBillTypeChange;
  
  if (newBillType && formRef.current) {
   
    setBillsObj({});
    setBillsObjName({});
    setBillsObjFileObjects({});
    setIsUploading({});
    documentSize = 0;
    setBillsObjSize({});
    setDocsErrorMessage({});
    
    setCategoryUploads([]);
    setIsCategoryMandatory({});
    setBillErrorMessage();
    setGetRulesMessage();
    setBillRules(null);
    setHasUnsavedChanges(false);
    setSelectedBillType(null);

    formRef.current.setTouched({});
    formRef.current.setErrors({});
    const resetValues = createResetFormValues(
      formRef.current.initialValues,
      {
        type: newBillType,
      }
    );
    formRef.current.setValues(resetValues);
    await sleep(150);
    setSelectedBillType(newBillType);
    setNavigationMode("edit");
    await filesToBeUploadedBasedOnBillType(newBillType);
  }
}, []);

    const bannerRedirectionAndLogEvent = (url, page, serviceName) => {
      try {
        let meta = {
          utm_source: utm_source,
          userEmployeeId: users.employeeId,
          pmEntityId: users.pmEntityId,
          email: users.emailId,
        };
        const eventLogPayload = {
          userId: users.mbUserId,
          event: page,
          info: page,
          meta: JSON.stringify(meta),
          serviceName: serviceName,
          appversion: utm_source,
          landedFrom: "Reimbursement Bill Details Page",
        };
        axios.post(eventLogUrl, eventLogPayload);
        window.open(url);
      } catch (error) {
        return;
      }
    };

    var settings = {
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      draggable: true,
      touchMove: true,
    };

    const optionalFieldPresent = useMemo(
      () => hasOptionalField(selectedBillType, billDetailsFormConstants),
      [selectedBillType]
    );

    const getValidationSchema = useCallback(() => {
      return generateValidationSchema(
        selectedBillType,
        billDetailsFormConstants
      );
    }, [selectedBillType]);

    const focusOnErrorRef = useRef();

    const categories = useMemo(() => {
      const relationName = selectedBeneficiary || sessionStorage.getItem("relationName");
      // relationName stores beneficiary name; map to relationId from users list
      let relationId = BENEF_MAP.SELF; // Default to BENEF_MAP.SELF (Self)
      if (users && relationName) {
        const beneficiary = users.benefs.find(
          (user) => user.name === relationName
        );
        // Use relationId as it matches the localStorage benefMappedServices keys
        relationId =
          beneficiary?.relationId?.toString() ||
          BENEF_MAP.SELF; // Ensure it's a string
      }
      return getBillCategories(relationId);
    }, [selectedBeneficiary, users]);
    const bannerClickHandler = handleBannerClick(
      token,
      props.accessToken
    )(bannerRedirectionAndLogEvent);

const checkForUnsavedChanges = useCallback(
  (currentValues) => {

     if (navigationMode === "edit") {
      return false;
    }

    if (!initialFormValues) {
      return false;
    }

    const billTypeChanged = 
      initialFormValues._originalBillType && 
      currentValues.type !== initialFormValues._originalBillType;
    
    if (billTypeChanged) {
      return true;
    }

    const hasFormChanges = Object.keys(currentValues).some((key) => {
      if (key === 'doc' || key === 'docNames' || key === 'categoryUploads' || 
          key === '_actualFileObjects' || key === '_originalBillType' || key === 'files') {
        return false;
      }
      
      const currentValue = currentValues[key];
      const initialValue = initialFormValues[key];
      if (key === "date" || key === "billDate") {
        return currentValue !== initialValue;
      }
      const normalizedCurrent = currentValue ?? "";
      const normalizedInitial = initialValue ?? "";

      return normalizedCurrent !== normalizedInitial;
    });

    const initialDocs = initialFormValues.doc || {};
    const currentDocs = billsObj || {};
    
    let hasDocumentChanges = false;
    const allCategories = new Set([
      ...Object.keys(initialDocs),
      ...Object.keys(currentDocs)
    ]);
     if (Object.keys(initialDocs).length !== Object.keys(currentDocs).length) {
      hasDocumentChanges = true;
    } else {
    for (const category of allCategories) {
      const initialCategoryDocs = initialDocs[category] || [];
      const currentCategoryDocs = currentDocs[category] || [];
      
      if (initialCategoryDocs.length !== currentCategoryDocs.length) {
        hasDocumentChanges = true;
        break;
      }
      
      const initialSorted = [...initialCategoryDocs].sort();
      const currentSorted = [...currentCategoryDocs].sort();
      const docsMatch = initialSorted.every((doc, idx) => doc === currentSorted[idx]);
      
      if (!docsMatch) {
        hasDocumentChanges = true;
        break;
      }
    }
  }
    const hadNoDocsInitially = Object.keys(initialDocs).length === 0;
    const hasDocsNow = Object.keys(currentDocs).length > 0;
    const docsAdded = hadNoDocsInitially && hasDocsNow;

    const finalResult = hasFormChanges || hasDocumentChanges || docsAdded || billTypeChanged;

    return finalResult;
  },
  [initialFormValues, billsObj,navigationMode]
);

  const goBackToConfirmation = useCallback(() => {
    setShowWarningDialog(false);
    setShowBillForm(false);
    setIsComingFromConfirmation(false);
    setNavigationMode("");
    setHasUnsavedChanges(false);

    if (initialFormValues && navigationMode === "edit") {
      const billToRestore = {
        ...initialFormValues,
        _actualFileObjects: initialFormValues._actualFileObjects || {},
      };
      
      const restoredBill = [...bill, billToRestore];
      setBill(restoredBill);
    }

    setInitialFormValues(null);

    if (formRef.current) {
      formRef.current.setValues({
        ...formRef.current.initialValues,
        pincode: formRef.current.values.pincode,
      });
    }

    setBillsObj({});
    setBillsObjName({});
    setBillsObjSize({});
    setBillsObjFileObjects({});
    setCategoryUploads([]);
    setIsUploading({});
    setDocsErrorMessage({});
    setBillErrorMessage();
    setSelectedBillType(null);
    setIsEditBill(false);
    documentSize = 0;
  }, [initialFormValues, navigationMode, bill]);

    return (
      <FormikStepper
        initialValues={{
          employeeDetails: "",
          type: "",
          billNo: "",
          date: "",
          billAmount: "",
          hospitalName: "",
          files: [],
          declaration: "",
          hasPrescription: "",
          prescriptionReason: "",
        }}
        onSubmit={async (values) => {
          values = { ...values, files };
        }}
        innerRef={formRef}
        showBillForm={showBillForm}
        bills={bill}
        checkForUnsavedChanges={checkForUnsavedChanges}
        goBackToConfirmation={goBackToConfirmation}
        formRef={formRef}
        onSaveBill={addBillRow}
        saveBillDisabled={saveBillDisabled}
        selectedBillType={selectedBillType}
        isComingFromConfirmation={isComingFromConfirmation}
        showWarningDialog={showWarningDialog}
        setShowWarningDialog={setShowWarningDialog}
        isDeclarationChecked={isDeclarationChecked}
        navigationMode={navigationMode}
        setNavigationMode={setNavigationMode}
        handleBillTypeChangeConfirm={handleBillTypeChangeConfirm}
        isInBillDetailsPage={isInBillDetailsPage}
      >
        {
          <FormikStep
            label="Employee and Bank Details"
            validationSchema={yup.object({
              employeeDetails: yup
                .string()
                .typeError("Required")
                .required("Required"),
            })}
          >
            {users && bank ? (
              <>
                <UserDetailsForm
                  accessToken={props.accessToken}
                  users={users}
                  bank={bank}
                  bankFlag={bankFlag}
                  setSelectedBeneficiary={setSelectedBeneficiary}
                />
                <BankDetailsForm
                  accessToken={props.accessToken}
                  users={users}
                  bank={bank}
                  bankFlag={bankFlag}
                  onSelect={onSelectBankHandler}
                  loadBankDetails={userAndBankDetails}
                  setSuccessToast={setSuccessToast}
                />
              </>
            ) : (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                {loading ? (
                  <CircularProgress color="inherit" />
                ) : (
                  <p sx={{ color: "#212529" }}>
                    <strong>{message}</strong>
                  </p>
                )}
              </Backdrop>
            )}
          </FormikStep>
        }
        <FormikStep
          label="Bill Details"
          validationSchema={getValidationSchema()}
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            {showBillForm ? (
              <>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "30px",
                  }}
                >
                  <Col
                    md={12}
                    lg={6}
                    sx={!isMobile(window.innerWidth) ? {
                      maxHeight: "calc(100vh - 250px)", 
                      overflowY: "auto",
                    } : {}}
                  >
                    <div>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "18px", md: "22px" },
                          marginBottom: 2,
                          color: "#252D38",
                        }}
                      >
                        Select Bill Type
                      </Typography>
                      <div>
                        <Grid item xs={12} md={4}>
                          <Select
                            sx={{
                              width: {
                                xs: "100%",
                                sm: "100%",
                                borderRadius: "16px",
                              },
                            }}
                            id="type"
                            name="type"
                            label="Bill Type *"
                            onSelect={(event) => {
                              filesToBeUploadedBasedOnBillType(event);
                            }}
                            options={categories}
                          />
                        </Grid>
                      </div>
                    </div>
                    <br></br>
                    {selectedBillType ? (
                      <div>
                        <Box>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "18px", md: "22px" },
                              marginBottom: 1,
                              color: "#252D38",
                            }}
                          >
                            Bill Details
                          </Typography>
                          {optionalFieldPresent && (
                            <p
                              style={{
                                fontSize: "14px",
                                color: "#47566A",
                                fontWeight: 400,
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <InfoOutlined sx={{ fontSize: "16px" }} /> Only
                              fields marked with * are mandatory
                            </p>
                          )}
                          <BillDetails
                            key={selectedBillType}
                            billType={selectedBillType}
                            accessToken={props.accessToken}
                            eligibleColumns={props.eligibleColumns}
                            benefMappedServices={benefMappedServices}
                            setFocusOnError={(fn) =>
                              (focusOnErrorRef.current = fn)
                            }
                            fileInputRefs={fileInputRefs}
                            billRules={billRules}
                          />
                          {categoryUploads && categoryUploads.length > 0 && !PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(Number(users?.pmEntityId)) ? (
                            <div className="Notes">
                              <h2
                                tabIndex={"0"}
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 500,
                                  color: "#252D38",
                                }}
                              >
                                Note:
                              </h2>
                              <ul
                                className="billNotes"
                                style={{
                                  fontSize: "14px",
                                  color: "#252D38",
                                  fontWeight: 400,
                                  listStyleType: "decimal",
                                }}
                              >
                                <li tabIndex={"0"}>
                                  Bills should be in original and pre-numbered
                                  from the doctor’s official receipt book.
                                  Receipts must mandatorily include pre-printed
                                  doctor’s information and receipt number. Blank
                                  document with the doctor’s signature/- stamp
                                  and letterhead bills are not acceptable
                                </li>
                                <li tabIndex={"0"}>
                                  A prescription must contain doctor's name,
                                  doctor's registered number, doctor's degree,
                                  patient name, date of appointment, signature
                                  and seal to be valid{" "}
                                </li>
                              </ul>
                            </div>
                          ) : (
                            <>
                              {getRulesMessage ? (
                                <p
                                  style={{
                                    marginTop: "10px",
                                    color: "#FC1721",
                                    display: "flex",
                                    justifyContent: "end",
                                    textAlign: "end",
                                  }}
                                >
                                  {getRulesMessage} &nbsp;
                                </p>
                              ) : null}
                            </>
                          )}
                          {categoryUploads && categoryUploads.length > 0 ? (
                            <>
                              <div className="docNeeded">
                                <h2
                                  tabIndex={"0"}
                                  style={{
                                    fontSize: "1.19rem",
                                    fontWeight: 600,
                                    color: "#252D38",
                                  }}
                                >
                                  Upload Documents
                                </h2>
                              </div>
                              <div>
                                <p
                                  id="text"
                                  tabIndex={"0"}
                                  style={{
                                    fontSize: "14px",
                                    color: "#47566A",
                                    fontWeight: 400,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <InfoOutlined
                                    sx={{ fontSize: "16px", color: "#1778F2" }}
                                  />
                                  Upload only jpg, png or pdf files. Size limit
                                  is 50MB
                                </p>
                              </div>
                              <div style={{ marginTop: "24px" }}>
                                {Object.keys(categoryUploads).map(
                                  (_, index) => {
                                    const hasUploadedFiles =
                                      billsObjName?.[categoryUploads?.[index]]
                                        ?.length > 0;

                                    return (
                                      <Box
                                        key={index}
                                        sx={{ marginBottom: "16px" }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            padding: "16px 0",
                                            borderBottom: "1px solid #E5E7EB",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontSize: "16px",
                                              fontWeight: 400,
                                              color: "#252D38",
                                            }}
                                          >
                                            {categoryUploads[index] === DocumentType.PRESCRIPTION &&
                                            selectedBillType === VACCINATION_CONTRACT &&
                                            PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(Number(localStorage.getItem(LocalStorageKeys.CURRENT_PM_ENTITY_ID)))
                                              ? VACCINATION_LABEL
                                              : categoryUploads[index].replace(
                                                  /_/g,
                                                  " "
                                                )}
                                            (s)
                                          </Typography>

                                          <input
                                            ref={(el) =>
                                              (fileInputRefs.current[
                                                categoryUploads[index]
                                              ] = el)
                                            }
                                            style={{ display: "none" }}
                                            disabled={isDisabled}
                                            name="files"
                                            type="file"
                                            id={`file-${categoryUploads[index]}`}
                                            multiple
                                            accept="image/jpeg,image/png,application/pdf"
                                            onChange={async (e) => {
                                             await addBillDocuements(
                                                e.target.files,
                                                index
                                              );
                                            }}
                                            onClick={(event) => {
                                              event.target.value = null;
                                              switch (categoryUploads[index]) {
                                                case "Bill_Invoice":
                                                  trackEvent.uploadBillClick({
                                                    screenName:
                                                      ScreenName.CREATE_CLAIM,
                                                  });
                                                  break;
                                                case "Prescription":
                                                  trackEvent.uploadRxClick({
                                                    screenName:
                                                      ScreenName.CREATE_CLAIM,
                                                  });
                                                  break;
                                                case "LabReport":
                                                  trackEvent.uploadReportClick({
                                                    screenName:
                                                      ScreenName.CREATE_CLAIM,
                                                  });
                                                  break;
                                                default:
                                                  break;
                                              }
                                            }}
                                          />
                                          <Button
                                            variant="outlined"
                                            disabled={isDisabled}
                                            startIcon={
                                              isUploading[
                                                categoryUploads[index]
                                              ] ? (
                                                <CircularProgress size="1rem" />
                                              ) : (
                                                <Box
                                                  component="span"
                                                  sx={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                    color: "#0066DC",
                                                  }}
                                                >
                                                  <img
                                                    src={UploadIcons}
                                                    alt="uploadIcon"
                                                    style={{
                                                      width: "17px",
                                                      height: "17px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </Box>
                                              )
                                            }
                                            onClick={() => {
                                              fileInputRefs.current[
                                                categoryUploads[index]
                                              ]?.click();
                                              switch (categoryUploads[index]) {
                                                case "Bill_Invoice":
                                                  trackEvent.uploadBillClick({
                                                    screenName:
                                                      ScreenName.CREATE_CLAIM,
                                                  });
                                                  break;
                                                case "Prescription":
                                                  trackEvent.uploadRxClick({
                                                    screenName:
                                                      ScreenName.CREATE_CLAIM,
                                                  });
                                                  break;
                                                case "LabReport":
                                                  trackEvent.uploadReportClick({
                                                    screenName:
                                                      ScreenName.CREATE_CLAIM,
                                                  });
                                                  break;
                                                default:
                                                  break;
                                              }
                                            }}
                                            sx={{
                                              borderColor: "#72B3FF",
                                              color: "#0066DC",
                                              borderRadius: "8px",
                                              padding: "8px 16px",
                                              textTransform: "none",
                                              fontSize: "14px",
                                              fontWeight: 500,
                                              minWidth: "100px",
                                              "&:hover": {
                                                borderColor: "#0052B4",
                                                backgroundColor: "#F0F7FF",
                                              },
                                              "&:disabled": {
                                                borderColor: "#BFC8D2",
                                                color: "#8A99AD",
                                              },
                                            }}
                                          >
                                            {isUploading[categoryUploads[index]]
                                              ? "Uploading..."
                                              : "Upload"}
                                          </Button>
                                        </Box>

                                        {hasUploadedFiles && (
                                          <UploadedFilesPreview
                                            billsObjName={billsObjName}
                                            category={categoryUploads[index]}
                                            billsObj={billsObj}
                                            billsObjFileObjects={
                                              billsObjFileObjects
                                            }
                                            setPreviewModal={setPreviewModal}
                                            onDelete={(idx) => {
                                              deleteSelectedFile(index, idx);
                                            }}
                                            DeleteIcon={DeleteIcon}
                                          />
                                        )}

                                        {/* Error Message */}
                                        {docsErrorMessage[
                                          categoryUploads[index]
                                        ] && (
                                          <Typography
                                            sx={{
                                              color: "#FC1721",
                                              fontSize: "14px",
                                              mt: 1,
                                              ml: 0,
                                            }}
                                          >
                                            {
                                              docsErrorMessage[
                                                categoryUploads[index]
                                              ]
                                            }
                                          </Typography>
                                        )}
                                      </Box>
                                    );
                                  }
                                )}
                              </div>

                              {/* Preview Modal Dialog */}
                              <Dialog
                                open={previewModal.open}
                                onClose={() => {
                                  setPreviewModal({
                                    open: false,
                                    url: null,
                                    isPdf: false,
                                    name: "",
                                    fileObject: null,
                                  });
                                  setPageNumber(1);
                                  setNumPages(null);
                                }}
                                maxWidth="md"
                                fullWidth
                                sx={{
                                  "& .MuiDialog-paper": {
                                    margin: { xs: "16px", sm: "32px" },
                                    maxHeight: {
                                      xs: "calc(100% - 32px)",
                                      sm: "90vh",
                                    },
                                    
                                    width: {
                                      xs: "calc(100% - 32px)",
                                      sm: "100%",
                                    },
                                  },
                                }}
                                PaperProps={{
                                  sx: {
                                    borderRadius: "12px",
                                  },
                                }}
                              >
                                {/* Header */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: {
                                      xs: "12px 16px",
                                      sm: "16px 24px",
                                    },
                                    borderBottom: "1px solid #E5E7EB",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: { xs: "14px", sm: "18px" },
                                      fontWeight: 600,
                                      color: "#252D38",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      maxWidth: "70%",
                                    }}
                                  >
                                    {previewModal.name}
                                  </Typography>
                                  <Box
                                    onClick={() => {
                                      setPreviewModal({
                                        open: false,
                                        url: null,
                                        isPdf: false,
                                        name: "",
                                        fileObject: null,
                                      });
                                      setPageNumber(1);
                                      setNumPages(null);
                                    }}
                                    sx={{
                                      cursor: "pointer",
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s ease",
                                      color: "#252D38",
                                    }}
                                  >
                                    <CloseIcon />
                                  </Box>
                                </Box>

                                {/* Content */}
                                <Box
                                  sx={{
                                    padding: { xs: "16px", sm: "24px" },
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    flex:1,
                                    minHeight: { xs: "200px", sm: "300px" },
                                    maxHeight: { xs: "60vh", sm: "70vh" },
                                    overflow: "auto",
                                  }}
                                >
                                  {previewModal.isPdf ? (
                                    <Box
                                      sx={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#F9FAFB",
                                          borderRadius: "8px",
                                          border: "1px solid #E5E7EB",
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          padding: "16px",
                                          overflow: "auto",
                                        }}
                                      >
                                        <Document
                                          file={previewModal.url}
                                          onLoadSuccess={onDocumentLoadSuccess}
                                          loading={
                                            <Box
                                              sx={{
                                                padding: "20px",
                                                textAlign: "center",
                                              }}
                                            >
                                              <CircularProgress size={40} />
                                              <Typography
                                                sx={{
                                                  mt: 2,
                                                  color: "#47566A",
                                                }}
                                              >
                                                Loading PDF...
                                              </Typography>
                                            </Box>
                                          }
                                          error={
                                            <Box
                                              sx={{
                                                padding: "20px",
                                                textAlign: "center",
                                              }}
                                            >
                                              <Typography
                                                sx={{ color: "#FC1721" }}
                                              >
                                                Failed to load PDF
                                              </Typography>
                                            </Box>
                                          }
                                        >
                                          <Page
                                            pageNumber={pageNumber}
                                            width={Math.min(
                                              window.innerWidth - 100,
                                              600
                                            )}
                                            renderTextLayer={true}
                                            renderAnnotationLayer={true}
                                          />
                                        </Document>

                                        {numPages && numPages > 1 && (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 2,
                                              mt: 2,
                                              padding: "8px 16px",
                                              backgroundColor: "#FFFFFF",
                                              borderRadius: "8px",
                                              border: "1px solid #E5E7EB",
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              disabled={pageNumber <= 1}
                                              onClick={() =>
                                                setPageNumber(pageNumber - 1)
                                              }
                                              sx={{
                                                minWidth: "40px",
                                                padding: "4px 8px",
                                                borderColor: "#0066DC",
                                                color: "#0066DC",
                                              }}
                                            >
                                              Prev
                                            </Button>
                                            <Typography
                                              sx={{
                                                fontSize: "14px",
                                                color: "#47566A",
                                              }}
                                            >
                                              Page {pageNumber} of {numPages}
                                            </Typography>
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              disabled={pageNumber >= numPages}
                                              onClick={() =>
                                                setPageNumber(pageNumber + 1)
                                              }
                                              sx={{
                                                minWidth: "40px",
                                                padding: "4px 8px",
                                                borderColor: "#0066DC",
                                                color: "#0066DC",
                                              }}
                                            >
                                              Next
                                            </Button>
                                          </Box>
                                        )}
                                      </Box>

                                      {!isMobile(window.innerWidth) && (<Button
                                        variant="outlined"
                                        onClick={() => {
                                          if (
                                            previewModal.url &&
                                            previewModal.fileObject
                                          ) {
                                            const link =
                                              document.createElement("a");
                                            link.href = previewModal.url;
                                            link.download =
                                              previewModal.name ||
                                              "document.pdf";
                                            link.click();
                                          }
                                        }}
                                        sx={{
                                          borderColor: "#0066DC",
                                          color: "#0066DC",
                                          borderRadius: "8px",
                                          padding: "8px 20px",
                                          textTransform: "none",
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          width: "100%",
                                          "&:hover": {
                                            borderColor: "#0052B4",
                                            backgroundColor: "#F0F7FF",
                                          },
                                        }}
                                      >
                                        Download PDF
                                      </Button>
                                      )}
                                    </Box>
                                  ) : previewModal.url ? (
                                    // Image Preview (unchanged)
                                    <Box
                                      sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: "100%",
                                          maxHeight: { xs: "50vh", sm: "60vh" },
                                          overflow: "auto",
                                          display: "flex",
                                          justifyContent: "center",
                                          backgroundColor: "#F9FAFB",
                                          borderRadius: "8px",
                                          padding: { xs: "8px", sm: "16px" },
                                          border: "1px solid #E5E7EB",
                                        }}
                                      >
                                        <img
                                          src={previewModal.url}
                                          alt={previewModal.name}
                                          style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                            borderRadius: "8px",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </Box>
                                      {!isMobile(window.innerWidth) && (<Button
                                        variant="outlined"
                                        onClick={() => {
                                          if (
                                            previewModal.url &&
                                            previewModal.fileObject
                                          ) {
                                            const link =
                                              document.createElement("a");
                                            link.href = previewModal.url;
                                            link.download =
                                              previewModal.name || "image.jpg";
                                            link.click();
                                          }
                                        }}
                                        sx={{
                                          borderColor: "#0066DC",
                                          color: "#0066DC",
                                          borderRadius: "8px",
                                          padding: "8px 20px",
                                          textTransform: "none",
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          width: { xs: "100%", sm: "auto" },
                                          "&:hover": {
                                            borderColor: "#0052B4",
                                            backgroundColor: "#F0F7FF",
                                          },
                                        }}
                                      >
                                        Download Image
                                      </Button>
                                      )}
                                    </Box>
                                  ) : (
                                    <Typography
                                      sx={{
                                        color: "#47566A",
                                        fontSize: { xs: "14px", sm: "16px" },
                                      }}
                                    >
                                      No preview available
                                    </Typography>
                                  )}
                                </Box>
                              </Dialog>
                            </>
                          ) : null}
                        </Box>
                      </div>
                    ) : null}

                    <p
                      tabIndex={"0"}
                      ref={errorRef}
                      style={{ color: "#FC1721" }}
                    >
                      {billErrorMessage}
                    </p>
                  </Col>
                  <Col
                    md={12}
                    lg={6}
                    className="banners"
                    style={{
                      position: "sticky",
                      top: "100px",
                      alignSelf: "flex-start",
                      maxHeight: "calc(100vh - 250px)",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "400px",
                        margin: "0 auto",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "12px",
                      }}
                    >
                      <Carousel
                        itemClassnames={"bannerImg"}
                        pageId={pageConfigurationPageIDs.CREATE_CLAIM_PAGE}
                        carouselId={
                          pageConfigurationCarouselIDs.REIM_CREATE_CLAIM_CAROUSEL
                        }
                        bannerOnClick={bannerClickHandler}
                        slidesToShow={1}
                      />
                    </Box>
                  </Col>
                </Row>
              </>
            ) : (
              <SavedBills
                bills={bill}
                deleteBillRow={deleteBillRow}
                editBillRowFunction={editBillRow}
                addAnotherBill={addAnotherBillHandler}
                userDetails={users}
                bannerClickHandler={bannerClickHandler}
                isDeclarationChecked={isDeclarationChecked}
                setIsDeclarationChecked={setIsDeclarationChecked}
              />
            )}
          </Row>
        </FormikStep>
      </FormikStepper>
    );
  }
  return (
    <>
      {successDialog ? (
        <SuccessClaim message={"submitted"} claimId={successClaim} />
      ) : (
        <>
          <div style={{ marginTop: "20px", alignItems: "center" }}>
            <FormikForm />
          </div>
        </>
      )}
      <Snackbar
        key={successToast.key}
        open={successToast.show}
        autoHideDuration={5000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
            zIndex: 1500,
            top: { xs: "auto", md: "80px" },
        }}
      >
        <Alert
          onClose={handleToastClose}
          severity="success"
          sx={{
            width: '100%',
            backgroundColor: "#252D38",
            color: "#FFFFFF",
            borderRadius: "8px",
            '& .MuiAlert-icon': {
                color: '#FFFFFF'
            },
            '& .MuiAlert-action': {
                color: '#FFFFFF'
            }
          }}
        >
          {successToast.message}
        </Alert>
      </Snackbar>
    </>
  );
}
